// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_items-loader_115pt_16l07_5:not(#\\9 ){display:inline}", ""]);
// Exports
module.exports = exports;
